import React, { useEffect, useState } from 'react';
import SesKaydiPlayerModal from './SesKaydiPlayerModal';
import { parseApiDate } from '../utils/security';
import './GelenCagriDetayModal.css';

const formatTarih = (val, metin) => {
  if (metin) return metin;
  const d = parseApiDate(val);
  if (!d || Number.isNaN(d.getTime())) return val || '—';
  return d.toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' });
};

const GelenCagriDetayModal = ({ cagri, onClose }) => {
  const [sesKaydiModal, setSesKaydiModal] = useState(null);
  const [acikBacakIdx, setAcikBacakIdx] = useState(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape' && !sesKaydiModal) onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, sesKaydiModal]);

  useEffect(() => {
    setAcikBacakIdx(null);
  }, [cagri]);

  if (!cagri) return null;

  const bacaklar = cagri.bacaklar?.length ? cagri.bacaklar : [cagri];
  const baslik = cagri.musteriAdi || 'Bilinmeyen müşteri';
  const telefon = cagri.telefon || cagri.arayan || '—';
  const kolonSayisi = 10;

  const toggleBacakDetay = (idx) => {
    setAcikBacakIdx((prev) => (prev === idx ? null : idx));
  };

  return (
    <>
      <div
        className="modal-overlay gelen-cagri-detay-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="gelen-cagri-detay-title"
        onClick={onClose}
      >
        <div className="gelen-cagri-detay-modal" onClick={(e) => e.stopPropagation()}>
          <div className="gelen-cagri-detay-modal__header">
            <div>
              <h2 id="gelen-cagri-detay-title" className="gelen-cagri-detay-modal__title">
                Çağrı detayı
              </h2>
              <p className="gelen-cagri-detay-modal__subtitle">
                {baslik} · {telefon}
                {cagri.bacakSayisi > 1 ? (
                  <span className="gelen-cagri-detay-modal__badge">
                    {cagri.bacakSayisi} santral kaydı
                  </span>
                ) : null}
              </p>
            </div>
            <button
              type="button"
              className="gelen-cagri-detay-modal__close"
              onClick={onClose}
              aria-label="Kapat"
            >
              <i className="fas fa-times" aria-hidden />
            </button>
          </div>

          <div className="gelen-cagri-detay-modal__ozet">
            <div className="gelen-cagri-detay-modal__ozet-item">
              <span className="label">Tarih</span>
              <span>{formatTarih(cagri.tarih, cagri.tarihMetin)}</span>
            </div>
            <div className="gelen-cagri-detay-modal__ozet-item">
              <span className="label">Süre</span>
              <span>{cagri.sureMetin || '—'}</span>
            </div>
            <div className="gelen-cagri-detay-modal__ozet-item">
              <span className="label">Durum</span>
              <span>{cagri.durum || '—'}</span>
            </div>
            <div className="gelen-cagri-detay-modal__ozet-item">
              <span className="label">Mesai</span>
              <span>{cagri.mesaiDisi ? 'Dışı' : 'İçi'}</span>
            </div>
            {cagri.commonId ? (
              <div className="gelen-cagri-detay-modal__ozet-item">
                <span className="label">commonID</span>
                <span className="mono">{cagri.commonId}</span>
              </div>
            ) : null}
          </div>

          <div className="gelen-cagri-detay-modal__body">
            <div className="gelen-cagri-detay-modal__table-wrap">
              <table className="gelen-cagri-detay-table">
                <colgroup>
                  <col className="col-tarih" />
                  <col className="col-arayan" />
                  <col className="col-aranan" />
                  <col className="col-sure" />
                  <col className="col-durum" />
                  <col className="col-mesai" />
                  <col className="col-hat" />
                  <col className="col-rehber" />
                  <col className="col-kayit" />
                  <col className="col-detay" />
                </colgroup>
                <thead>
                  <tr>
                    <th>Tarih</th>
                    <th>Arayan</th>
                    <th>Aranan</th>
                    <th>Süre</th>
                    <th>Durum</th>
                    <th>Mesai</th>
                    <th>Hat</th>
                    <th>Rehber</th>
                    <th className="col-icon">Kayıt</th>
                    <th className="col-icon">Detay</th>
                  </tr>
                </thead>
                <tbody>
                  {bacaklar.map((b, idx) => (
                    <React.Fragment key={b.uniqueid ? `${b.uniqueid}-${idx}` : idx}>
                      <tr className={acikBacakIdx === idx ? 'is-expanded' : undefined}>
                        <td>{formatTarih(b.tarih, b.tarihMetin)}</td>
                        <td>{b.telefon || b.arayan || '—'}</td>
                        <td className="cell-wrap">{b.aranan || '—'}</td>
                        <td>{b.sureMetin || '—'}</td>
                        <td>
                          <span className={`gelen-cagri-detay-durum gelen-cagri-detay-durum--${b.yon === 1 ? 'ok' : 'miss'}`}>
                            {b.durum || (b.yon === 1 ? 'Cevap' : 'Cevapsız')}
                          </span>
                        </td>
                        <td>{b.mesaiDisi ? 'Dışı' : 'İçi'}</td>
                        <td className="cell-wrap">{b.hat || '—'}</td>
                        <td className="cell-wrap">{b.rehber || '—'}</td>
                        <td className="col-icon">
                          {b.sesKaydi ? (
                            <button
                              type="button"
                              className="ses-kaydi-dinle-btn ses-kaydi-dinle-btn--compact"
                              onClick={() => setSesKaydiModal({ ...cagri, ...b, sesKaydi: b.sesKaydi })}
                              title="Ses kaydını dinle"
                              aria-label="Ses kaydını dinle"
                            >
                              <i className="fas fa-circle-play" aria-hidden />
                            </button>
                          ) : (
                            <span className="ses-kaydi-empty">—</span>
                          )}
                        </td>
                        <td className="col-icon">
                          <button
                            type="button"
                            className={`ses-kaydi-info-btn ses-kaydi-info-btn--compact${acikBacakIdx === idx ? ' is-active' : ''}`}
                            onClick={() => toggleBacakDetay(idx)}
                            title="Bacak detayını göster"
                            aria-label="Bacak detayını göster"
                            aria-expanded={acikBacakIdx === idx}
                          >
                            <i className="fas fa-circle-info" aria-hidden />
                          </button>
                        </td>
                      </tr>
                      {acikBacakIdx === idx ? (
                        <tr className="gelen-cagri-detay-expand">
                          <td colSpan={kolonSayisi}>
                            <dl className="gelen-cagri-detay-expand__grid">
                              <div>
                                <dt>uniqueid</dt>
                                <dd className="mono">{b.uniqueid || '—'}</dd>
                              </div>
                              <div>
                                <dt>commonID</dt>
                                <dd className="mono">{b.commonId || cagri.commonId || '—'}</dd>
                              </div>
                              <div>
                                <dt>Yön</dt>
                                <dd>{b.yon === 1 ? '1 · Gelen cevaplanan' : b.yon === 2 ? '2 · Gelen cevapsız' : b.yon ?? '—'}</dd>
                              </div>
                              <div>
                                <dt>Süre (sn)</dt>
                                <dd>{b.sureSn ?? '—'}</dd>
                              </div>
                              <div className="span-full">
                                <dt>Aranan (tam)</dt>
                                <dd className="mono">{b.aranan || '—'}</dd>
                              </div>
                              <div className="span-full">
                                <dt>Rehber (tam)</dt>
                                <dd className="mono">{b.rehber || '—'}</dd>
                              </div>
                              {b.sesKaydi ? (
                                <div className="span-full">
                                  <dt>Ses kaydı URL</dt>
                                  <dd className="mono break-all">{b.sesKaydi}</dd>
                                </div>
                              ) : null}
                            </dl>
                          </td>
                        </tr>
                      ) : null}
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {sesKaydiModal && (
        <SesKaydiPlayerModal
          kayit={sesKaydiModal}
          onClose={() => setSesKaydiModal(null)}
        />
      )}
    </>
  );
};

export default GelenCagriDetayModal;
